import { atom } from "recoil";

export const selectedMode = atom({
  key: "selectedMode",
  default: null,
});
